// Seeded RNG (mulberry32). Deterministic so Edge Functions and browser can
// agree on shuffle order given the same seed. Never use Math.random() inside
// engine modules — pass an rng() function in as an argument.

export function createRng(seed) {
  let s = (seed >>> 0) || 1;
  return function rng() {
    s = (s + 0x6d2b79f5) >>> 0;
    let t = s;
    t = Math.imul(t ^ (t >>> 15), t | 1);
    t ^= t + Math.imul(t ^ (t >>> 7), t | 61);
    return ((t ^ (t >>> 14)) >>> 0) / 4294967296;
  };
}

export function makeSeed() {
  // Acceptable as a seed *generator* at the edges of the system; the engine
  // itself never calls this. Edge Functions should use crypto.getRandomValues.
  return (Math.random() * 0xffffffff) >>> 0;
}
